/* eslint-disable react/prefer-stateless-function */
// TODO make SystemLockscreen a pure function
import React from 'react'
import { Helmet } from 'react-helmet'
import { Result } from 'antd'

import 'antd/lib/result/style'

class SystemLockscreen extends React.Component {
  render() {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
      >
        <Helmet title="Lockscreen" />
      </Result>
    )
  }
}

export default {
  name: 'Lockscreen',
  routeProps: {
    path: '/locked',
    component: SystemLockscreen,
  },
}
